export default "__VITE_ASSET__CGLfFYJG__"